import { Button } from "@xola/ui-kit";
import React from "react";
import { useHistory } from "react-router-dom";
import { HeaderToolBarActions } from "../../Common/HeaderToolbarActions";
import { ContentLayout } from "../../Layout/ContentLayout";
import { TaxAndFeeList } from "./TaxAndFeeList";
import { TaxesAndFeesPreferences } from "./TaxAndFeesPreferences";

export const TaxesAndFeesSettings = () => {
    const history = useHistory();

    const handleAddTaxAndFeeClick = () => {
        history.push("/settings/taxesAndFees/create");
    };

    return (
        <ContentLayout isWide className="space-y-4 divide-y divide-gray-lighter">
            <HeaderToolBarActions>
                <Button onClick={handleAddTaxAndFeeClick}>Add Tax/Fee</Button>
            </HeaderToolBarActions>
            <div>
                <h2 className="my-4">Taxes &amp; Fees</h2>
                <TaxAndFeeList />
                <div className="mt-14 border-b border-gray-light " />
                <TaxesAndFeesPreferences />
            </div>
        </ContentLayout>
    );
};
